import { CircularProgress, Stack } from '@mui/material'

const LoadingScreen = ({ isLoading }: { isLoading?: boolean }) => (
  <Stack
    direction="column"
    justifyContent="center"
    alignItems="center"
    height="100vh"
    bgcolor={!isLoading ? 'background.default' : 'rgba(255, 255, 255, 0.5)'}
    top="0"
    zIndex={99999999}
    width="100%"
    position={'fixed'}
  >
    <CircularProgress />
  </Stack>
)

export default LoadingScreen
